import { MediaRowBase } from '@components/common/MediaRowBase/MediaRowBase';
import baseCss from '@components/common/MediaRowBase/MediaRowBase.module.scss';
import classNames from 'classnames';
import React from 'react';
import css from './InvoiceHeaderRow.module.scss';

interface InvoiceHeaderRowProps {
  totalInvoices: number;
  selectedInvoices: number;
  onSelectAllToggle: () => void;
  isAllSelected: boolean;
  isPartiallySelected: boolean;
  showCheckbox?: boolean;
}

export const InvoiceHeaderRow: React.FC<InvoiceHeaderRowProps> = ({
  totalInvoices,
  selectedInvoices,
  onSelectAllToggle,
  isAllSelected,
  isPartiallySelected,
  showCheckbox = true,
}) => {
  const rightContent = (
    <>
      <div className={classNames(baseCss.thumbnailContainer, css.invoiceHeaderInfo)}>
        <div className={css.bulletSeparated}>
          <span className={classNames(css.bulletItem, baseCss.headerCell)}>&nbsp;</span>
        </div>
      </div>
      <span
        className={classNames(css.creditsObtainedHeader, baseCss.headerCell, css.sortableHeader)}
      >
        Credits Obtained
      </span>
      <span className={classNames(css.creditsUsedHeader, baseCss.headerCell, css.sortableHeader)}>
        Credits Used
      </span>
      <span
        className={classNames(css.transactionDateHeader, baseCss.headerCell, css.sortableHeader)}
      >
        Transaction Date
      </span>
      <span className={classNames(css.expiryDateHeader, baseCss.headerCell, css.sortableHeader)}>
        Expiry Date
      </span>
      <span className={classNames(css.typeHeader, baseCss.headerCell, css.sortableHeader)}>
        Type
      </span>
    </>
  );

  return (
    <MediaRowBase
      variant="header"
      tableTheme="invoice"
      showCheckbox={showCheckbox}
      checkboxContent={null}
      rightContent={rightContent}
      className={css.invoiceHeaderRow}
    />
  );
};
